export default __webpack_public_path__ + "static/media/Security_and_privacy.0e40aa72.jpg";